"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowCheckBoxEditor_1 = require("../../../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowButtonSet_1 = require("../../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../../../shared/components/containers/CardEditorContainer");
var CardRowNumericEditor_1 = require("../../../../../../../../shared/components/editors/CardRowNumericEditor");
var BrandCurrencyEditor = /** @class */ (function (_super) {
    __extends(BrandCurrencyEditor, _super);
    function BrandCurrencyEditor(props) {
        return _super.call(this, props) || this;
    }
    BrandCurrencyEditor.prototype.componentWillMount = function () {
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    app_currency_id: _item.app_currency_id,
                    app_currency_title: _item.app_currency_title,
                    is_default: _item.is_default,
                    is_tournament: _item.is_tournament,
                    min_amount_to_show: _item.min_amount_to_show
                });
            }
        }
        else {
            this.setState({
                app_currency_id: 0,
                app_currency_title: "",
                is_default: false,
                is_tournament: false,
                min_amount_to_show: 0
            });
        }
        this.doReSetRules();
    };
    BrandCurrencyEditor.prototype.doReSetRules = function () {
        this.setState({
            app_currency_rules: { isError: false },
        });
    };
    BrandCurrencyEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.app_currency_id <= 0) || (this.state.app_currency_title.length === 0)) {
            this.setState({ app_currency_rules: { isError: true, errorMessage: "Валюта не выбрана!" } });
            return false;
        }
        //if ((this.state.min_amount_to_show <= 0)) {
        //    this.setState({ min_amount_to_show_rules: { isError: true, errorMessage: "Минимальная сумма отображения выигрыша не указана!" } })
        //    return false;
        //}
        return true;
    };
    BrandCurrencyEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                app_currency_id: this.state.app_currency_id,
                is_default: this.state.is_default,
                is_tournament: this.state.is_tournament,
                min_amount_to_show: this.state.min_amount_to_show
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Валюта бренда изменена!");
            });
        }
    };
    BrandCurrencyEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                app_currency_id: this.state.app_currency_id,
                brand_id: this.props.rootRecord.key,
                is_default: this.state.is_default,
                is_tournament: this.state.is_tournament,
                min_amount_to_show: this.state.min_amount_to_show
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Валюта бренда добавлена!");
            });
        }
    };
    BrandCurrencyEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BrandCurrencyEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Новая валюта бренда";
        }
        else {
            return "Изменить валюту бренда";
        }
    };
    BrandCurrencyEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 350 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Валюта:", placeholder: "Выберите валюту" }, value: { key: this.state.app_currency_id, value: this.state.app_currency_title }, onValueChanged: function (newVal) { _this.setState({ app_currency_id: newVal.key, app_currency_title: newVal.value, app_currency_rules: { isError: false } }); }, items: this.props.availCurrency, required: true, rules: this.state.app_currency_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Мин. сум. отобр. выигрыша", placeholder: "Введите мин сумму отображения выигрыша" }, values: { max: 999999, min: 0, value: this.state.min_amount_to_show }, onValueChanged: function (newVal) {
                    _this.setState({
                        min_amount_to_show: newVal
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Основная валюта", value: this.state.is_default, onChecked: function (checked) { _this.setState({ is_default: checked }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Турнирная валюта", value: this.state.is_tournament, onChecked: function (checked) { _this.setState({ is_tournament: checked }); } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnNew: "Создать", btnEdit: "Изменить", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return BrandCurrencyEditor;
}(React.Component));
exports.default = BrandCurrencyEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ui/component/options/currency/BrandCurrencyEditor.tsx
// module id = 1765
// module chunks = 0